import axios from 'axios';

const state = {
  offers: [],
  isLoading: false,
  totalOffers: 0,
};

const getters = {
  offers: (state) => state.offers,
  isLoading: (state) => state.isLoading,
  totalOffers: (state) => state.totalOffers,
};

const mutations = {
  SET_OFFERS(state, offers) {
    state.offers = offers;
  },
  SET_TOTAL_OFFERS(state, total) {
    state.totalOffers = total;
  },
  SET_LOADING(state, flag) {
    state.isLoading = flag;
  },
  SET_FLAG(state, { id, key, value }) {
    const idx = state.offers.findIndex(o => o.id === id);
    if (idx !== -1) {
      state.offers[idx][key] = value;
    }
  },
};

// — те же вспомогалки для поиска статусов, что и в основном модуле —
const RAW_STATUSES = [
  'in process',
  'accept',
  'rejected',
  'Request for invoice',
  'Invoice and contract sent',
  'typo_finish',
  'stock',
  'wap',
  'done',
  'archieve',
];

const normalize = (s) => (s ?? '').toString().toLowerCase().trim();

const STATUS_ALIASES = {
  'в работе': 'in process',
  'работа': 'in process',
  'принят': 'accept',
  'отклонен': 'rejected',
  'запрос счета': 'Request for invoice',
  'счет и договор отправлены': 'Invoice and contract sent',
  'типография завершена': 'typo_finish',
  'склад': 'stock',
  'ожидание оплаты': 'wap',
  'сдан': 'done',
  'архив': 'archieve',
  'archive': 'archieve',
};

function toRawStatusIfAny(input) {
  const q = normalize(input);
  if (!q) return null;

  const exactRaw = RAW_STATUSES.find((k) => normalize(k) === q);
  if (exactRaw) return exactRaw;

  for (const [alias, raw] of Object.entries(STATUS_ALIASES)) {
    if (normalize(alias) === q) return raw;
  }

  for (const raw of RAW_STATUSES) {
    if (normalize(raw).includes(q)) return raw;
  }
  for (const [alias, raw] of Object.entries(STATUS_ALIASES)) {
    if (normalize(alias).includes(q) || q.includes(normalize(alias))) return raw;
  }

  return null;
}

function buildOfferParams(base = {}) {
  const params = { per_page: 50, sort_by: 'created_at', sort_dir: 'desc', ...base };
  if (params.search && params.search.toString().trim()) {
    const raw = toRawStatusIfAny(params.search);
    if (raw) params.search = raw;
  }
  return params;
}

const actions = {
  async fetchOffersPaginated({ commit }, { page = 1, per_page = 50, search = '', sort_by = 'created_at', sort_dir = 'desc' }) {
    commit('SET_LOADING', true);
    try {
      const token = localStorage.getItem('token');
      const params = buildOfferParams({ page, per_page, search, sort_by, sort_dir });

      const response = await axios.get('https://apidash.smartpress.kz/api/offers-archived', {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      commit('SET_OFFERS', response.data.data);
      commit('SET_TOTAL_OFFERS', response.data.total);
    } catch (e) {
      console.error('Error fetching archived offers:', e);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async toggleFlag({ commit, dispatch }, { id, key, value }) {
    const token = localStorage.getItem('token');
    const keyMap = {
      isbn: 'has_isbn',
      contract_file: 'has_contract',
      invoice_file: 'has_invoice',
      act_file: 'has_act',
      esf_file: 'has_esf',
      author_contract_file: 'has_author_contract',
      author_copies: 'has_author_copies',
      sales_contract_file: 'has_sales_contract',
      in_price: 'in_price',
      in_store: 'in_store',
    };
    const dbKey = keyMap[key] || key;

    // оптимистично
    commit('SET_FLAG', { id, key: dbKey, value });

    try {
      await axios.patch(
        `https://apidash.smartpress.kz/api/offers/${id}/toggle-flag`,
        { key: dbKey, value },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // перезагрузка первой страницы архива
      await dispatch('fetchOffersPaginated', {
        page: 1,
        per_page: 50,
        search: '',
        sort_by: 'created_at',
        sort_dir: 'desc',
      });
    } catch (e) {
      // откат
      commit('SET_FLAG', { id, key: dbKey, value: !value });
      throw e;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
